import keyMirror from 'keymirror';

const PartyPanelProfileTabs = keyMirror({
  QUICK: null,
  NOTES: null,
  TAGS: null,
});

export default PartyPanelProfileTabs;
